import { render } from "./GalleryMark.vue?vue&type=template&id=686603a4&scoped=true"
import script from "./GalleryMark.vue?vue&type=script&lang=js"
export * from "./GalleryMark.vue?vue&type=script&lang=js"

import "./GalleryMark.vue?vue&type=style&index=0&id=686603a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686603a4"]])

export default __exports__